<template>
  <div
    class="sort"
    @click="$emit('sortBy', row)"
    :class="{ floatRight: this.floatRight == 'yes' }"
  >
    <div
      class="sort-image"
      :class="{ active: this.currentSortRow == row }"
    ></div>
    <div class="sort-text" :class="{ active: this.currentSortRow == row }">
      {{ sortDirectionText(row, type) }}
    </div>
  </div>
</template>

<script>
export default {
  name: "SortButton",
  props: {
    row: String, // nazev row, podle ktere chceme radit, v pripade ze radime podle id z jineho arraye, pouzivam nazevRow#pomocnyArray#nazevRowPomocnehoArraye
    type: String, // typ, a = text (A-Z); 0 = cisla (0-9) - ciste esteticke
    currentSortDirection: Number,
    currentSortRow: String,
    floatRight: {
      type: String,
      default: "no",
    }, // optional, pokud se zada yes, floatuje napravo - pouzil bych boolean, ale to se Vue nezdalo..
  },
  methods: {
    sortDirectionText: function (row, type) {
      var smer = 1;
      if (this.currentSortRow == row) {
        smer = this.currentSortDirection;
      }
      if (type == "a") {
        return smer == 1 ? "A-Z" : "Z-A";
      }
      if (type == "0") {
        return smer == 1 ? "1-9" : "9-1";
      }

      return "?-?";
    },
  },
};
</script>